import { render, staticRenderFns } from "./CellInfo.vue?vue&type=template&id=0713ba0a&scoped=true"
import script from "./CellInfo.vue?vue&type=script&lang=js"
export * from "./CellInfo.vue?vue&type=script&lang=js"
import style0 from "./CellInfo.vue?vue&type=style&index=0&id=0713ba0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713ba0a",
  null
  
)

export default component.exports